const customActivateData = {
  init: function() {
    if (!this.component.length)
      return

    this.addEventListeners()
  },

  addEventListeners: function() {
    this.component.forEach(inputDate => this.insertMinDateAttribute(inputDate))
    this.component.forEach(inputDate => inputDate.addEventListener('input', this.breackOldDates.bind(this)))
  },

  breackOldDates: function({ target }) {
    if (target.value < this.todayDate)
      target.value = this.todayDate
  },

  insertMinDateAttribute: function(inputDate) {
    inputDate.setAttribute('min', this.todayDate)
  },

  component: document.querySelectorAll('[data-component="custom-activate-data"] [data-element="date-input"]'),
  todayDate: new Date().toISOString().split("T")[0]
}

customActivateData.init()






